module.exports = __webpack_public_path__ + "static/media/shopify.dbd567aa.svg";